module.exports = __webpack_public_path__ + "static/media/152.ca4afa73.wav";